import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { setHolidays } from '../../../store/slices/holiday.slice';

const useHttpGetHolidaysByYearOnMount = (year: number) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isReady, setIsReady] = useState(false);

    const exec = () => {
        const { exec, abort } = organizationApi.getHolidaysByYear({
            query: {
                year,
            },
            onSuccess: res => {
                dispatch(setHolidays(res.body));
            },
            onError: error => console.log(error),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(exec, [year]);
    return { isReady, exec };
};

export default useHttpGetHolidaysByYearOnMount;
